// AvatarStack — overlapping row of avatars. Beyond `max`, the overflow
// collapses into a "+N" avatar so the row stays a fixed footprint.

import { Children, type ReactNode } from 'react';

export interface AvatarStackProps {
  children: ReactNode;
  /** Max avatars shown before collapsing the rest into "+N". */
  max?: number;
  /** Diameter of the overflow "+N" chip, px. Match your avatar size. */
  size?: number;
  className?: string;
}

const AvatarStack = ({ children, max, size = 34, className = '' }: AvatarStackProps) => {
  const items = Children.toArray(children);
  const shown = max != null && items.length > max ? items.slice(0, max) : items;
  const overflow = items.length - shown.length;
  const classes = ['app-avatar-stack', className].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      {shown}
      {overflow > 0 && (
        <span
          className='app-avatar app-avatar--more'
          style={{ width: size, height: size, fontSize: size * 0.34 }}
        >
          +{overflow}
        </span>
      )}
    </div>
  );
};

export default AvatarStack;
